import { useState } from "react";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledTooltip,
} from "reactstrap";

const SortDropdown = ({ onSortChange }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [sortConfig, setSortConfig] = useState({ field: null, direction: null });

  const toggleDropdown = () => setDropdownOpen((prev) => !prev);

  
  const fields = [
    { label: "Name", value: "first_name", icon: "mdi-account" },
    { label: "Created At", value: "created_at", icon: "mdi-calendar-plus" },
    { label: "Updated At", value: "updated_at", icon: "mdi-calendar-sync" },
  ];

  const handleSort = (field, direction = "asc") => {
    const newConfig = { field, direction };
    setSortConfig(newConfig);
    onSortChange(newConfig);
  };
  const clearSort = () => {
    setSortConfig({ field: null, direction: null });
    onSortChange({ field: null, direction: null });
  };

  return (
    <div style={{ position: "relative" }}>
      <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown} direction="down">
        <DropdownToggle
          className="p-1 text-black fs-6"
          size="sm"
          style={{ backgroundColor: "white" }}
        >
            
          <i className="mdi mdi-sort fs-5 me-1"></i>
          {/* {sortConfig?.field !== null && ( */}
  {/* <>
    <i
      id="clear-sort"
      className="mdi mdi-close-circle text-danger fs-5 position-absolute"
      style={{ cursor: "pointer", top: "6px", right: "8px", zIndex: 1100 }}
      onClick={clearSort}
    />
    <UncontrolledTooltip target="clear-sort">
      Clear Sorting
    </UncontrolledTooltip>
  </> */}
{/* )} */}


          {/* <UncontrolledTooltip target="clear-sort">
            Clear Sorting
          </UncontrolledTooltip> */}
        </DropdownToggle>

        <DropdownMenu
          end={false}
          style={{ transform: "translateX(-80%)", minWidth: "230px", zIndex: 1050 }}
        >
          {fields.map((field, index) => {
            const isSelected = sortConfig.field === field.value;
            return (
              <DropdownItem
                key={field.value}
                className="d-flex justify-content-between align-items-center dropdown-hover-item py-2"
                onClick={() => handleSort(field.value)} // Default ascending
              >
                <div className="d-flex align-items-center">
                  <i className={`mdi ${field.icon} me-2 text-primary fs-6`} />
                  <span className="fw-medium">{field.label}</span>
                </div>

                <div className="d-flex align-items-center" onClick={(e) => e.stopPropagation()}>
                  <i
                    id={`asc-${index}`}
                    className={`mdi mdi-arrow-up fs-5 mx-1 cursor-pointer ${
                      isSelected && sortConfig.direction === "asc" ? "text-success" : "text-muted"
                    }`}
                    onClick={() => handleSort(field.value, "asc")}
                  />
                  <UncontrolledTooltip target={`asc-${index}`}>
                    Sort Ascending
                  </UncontrolledTooltip>

                  <i
                    id={`desc-${index}`}
                    className={`mdi mdi-arrow-down fs-5 mx-1 cursor-pointer ${
                      isSelected && sortConfig.direction === "desc" ? "text-danger" : "text-muted"
                    }`}
                    onClick={() => handleSort(field.value, "desc")}
                  />
                  <UncontrolledTooltip target={`desc-${index}`}>
                    Sort Descending
                  </UncontrolledTooltip>
                </div>
              </DropdownItem>
            );
          })}
        </DropdownMenu>
      </Dropdown>
    </div>
  );
};

export default SortDropdown;
